var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluePaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "description-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2465",
    "data-name": "Caminho 2465",
    d: "M0,0H22V22H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2466",
    "data-name": "Caminho 2466",
    d: "M13.821,2H5.964A1.923,1.923,0,0,0,4.01,3.886L4,18.971a1.923,1.923,0,0,0,1.954,1.886h11.8a1.932,1.932,0,0,0,1.964-1.886V7.657Zm1.964,15.086H7.929V15.2h7.857Zm0-3.771H7.929V11.429h7.857ZM12.839,8.6V3.414l5.4,5.186Z",
    transform: "translate(-0.857 -0.429)",
    fill: "#012d5c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePaper);
export default __webpack_public_path__ + "static/media/Blue_paper.86ba6119.svg";
export { ForwardRef as ReactComponent };